import React from 'react';
import * as S from './styled';

const PlainButton = ({
  children,
  icon,
  hideIcon = false,
  disabled,
  className = '',
  width,
  center,
  bold,
  ...rest
}) => (
  <S.StyledPlainButton
    type="button"
    icon={icon}
    className={`${className} ${disabled ? 'disabled' : ''}`}
    disabled={disabled}
    {...rest}
    width={width}
    center
  >
    <S.ContentWrapper bold={bold}>
      {children}
      {icon && !hideIcon && <S.ButtonIcon icon={icon} />}
    </S.ContentWrapper>
  </S.StyledPlainButton>
);

export default PlainButton;
